
(function () {
    var window_width = null;
    let isMobile = false;
    let menu = document.getElementById("menu");
    let statusOpenMenu = false;
    let statusOpenSubmenu = false;
    var btnMenu = null;
    var submenus = null;
    var btnSubmenuLevelOne = null;
    var btnSubmenu = null;
    var btnSubmenuLevelTwo = null;

    var body = null;
    var coverhead = null;
    var btnCloseMenu = null;

    var optionLevelOne = null;
    var optionLevelTwo = null;

    var isMenuOpen = false;
    var isSubmenuOpen = false;
    var isSubmenuGrandChildOpen = false;

    var sectionHeader = null;
    var sectionHeaderValue = null;

    var optionUser = null;
    var optionUserSubmenu = null;
    var isOptionUser = false;
    var isCelPhone = false;

    var oldSubmenuFirstLevel = null;
    var actualSubmenuFirstLevel = null;
    
    var oldSubmenuSecondLevel = null;
    var actualSubmenuSecondLevel = null;
    
    var oldButtonFirstLevel = null;
    var clickedFirstLevel = 0;
    
    var oldButtonSecondtLevel = null;
    var clickedSecondLevel = 0;


    document.addEventListener("DOMContentLoaded", (ev) => {
        widthActual();
        getDevice();
        getTypeHeader();

        submenus = document.getElementsByClassName('submenu');
        btnSubmenu = document.getElementsByClassName('btn-submnenu');

        btnSubmenuLevelOne = document.getElementsByClassName('btn-submnenu-level-1');
        btnSubmenuLevelTwo = document.getElementsByClassName('btn-submnenu');

        optionLevelOne = document.getElementsByClassName('menu-item');
        optionLevelTwo = document.getElementsByClassName('submenu-item');

        optionUser = document.getElementsByClassName('navIcons__item--user');
        optionUserSubmenu = document.getElementsByClassName('submenuUser');
        body = document.getElementsByTagName('body');
        coverhead = document.getElementsByClassName('coverhead');

        $("#btn-menu").click(function () {
            isMenuOpen = !isMenuOpen;

            if (window_width < 768) {
                if (isMenuOpen == true) {
                    $(menu).addClass('show');
                    $(body).css('overflow', 'hidden');
                    $(coverhead).css('display', 'block');

                } else {
                    $(menu).removeClass('show');
                    $(body).css('overflow', 'auto');
                    $(coverhead).css('display', 'none');
                }
            }
        });

        $("#btn-close-menu").click(function () {
            if (isMenuOpen == true) {
                isMenuOpen = !isMenuOpen;
                $(menu).removeClass('show');
                $(body).css('overflow', 'auto');
                $(coverhead).css('display', 'none');
            }
        });

        hiddeMenuMobile();
        hideOptionUser();

        if (window_width < 768) {
            for (let i = 0; i < btnSubmenuLevelOne.length; i++) {
                btnSubmenuLevelOne[i].addEventListener("click", function () {
                    var submenuGrandchild = btnSubmenuLevelOne[i].parentElement.parentElement.parentElement.nextElementSibling;
                    isSubmenuOpen = true;
                    clickedFirstLevel = clickedFirstLevel + 1;
                    let iconToggle = btnSubmenuLevelOne[i].getElementsByClassName('icon-mobile')[0];

                    watcherSubmenuFirstLevel(oldSubmenuFirstLevel, submenuGrandchild);

                    if(clickedFirstLevel == 1) {
                        toggleClassIconFirstLevel(oldButtonFirstLevel, btnSubmenuLevelOne[i]);
                        oldButtonFirstLevel = btnSubmenuLevelOne[i];
                    } else {
                        toggleClassIconFirstLevel(oldButtonFirstLevel, btnSubmenuLevelOne[i]);
                    }
                });
            }

            for (let i = 0; i < optionLevelTwo.length; i++) {
                optionLevelTwo[i].addEventListener("click", function () {
                    var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                    watcherSubmenuSecondLevel(oldSubmenuSecondLevel, submenuGrandchild);
                    let btnSubmenuLevelTwo = optionLevelTwo[i].getElementsByClassName('btn-submnenu')[0];
                    clickedSecondLevel = clickedSecondLevel + 1;

                    if(clickedSecondLevel == 1) {
                        toggleClassIconSecondLevel(oldButtonSecondtLevel, btnSubmenuLevelTwo);
                        oldButtonSecondtLevel = btnSubmenuLevelTwo;
                    } else {
                        toggleClassIconSecondLevel(oldButtonSecondtLevel, btnSubmenuLevelTwo);
                    }
                });
            }
        } 
        
        if(window_width >= 768) {
            for (let i = 0; i < optionLevelOne.length; i++) {
                optionLevelOne[i].addEventListener("mouseenter", function () {
                    var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                    var btnSubList = this.querySelector('.menu-item__sublist');
                    var btnSubListLink = this.querySelector('.menu-item__link');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = this.querySelector('.icon');
                    }

                    $(btnSubList).addClass('hover');

                    if (btnSubListLink) {
                        $(btnSubListLink).addClass('hover');
                    }

                    if (btnCollapserSecondLevel) {
                        isSubmenuOpen = true;
                        $(submenuBtnToggleIcon).addClass('hover');

                        if (isSubmenuOpen == true) {
                            btnCollapserSecondLevel.ariaExpanded = 'true';
                            let submenu = btnCollapserSecondLevel.parentElement.parentElement.parentElement.nextElementSibling;
                        }
                    }
                });
            }

            for (let i = 0; i < optionLevelOne.length; i++) {
                optionLevelOne[i].addEventListener("mouseleave", function () {
                    var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                    var btnSubList = this.querySelector('.menu-item__sublist');
                    var btnSubListLink = this.querySelector('.menu-item__link');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                    }

                    $(btnSubList).removeClass('hover');

                    if (btnSubListLink) {
                        $(btnSubListLink).removeClass('hover');
                    }

                    if (btnCollapserSecondLevel) {
                        $(submenuBtnToggleIcon).removeClass('hover');
                        btnCollapserSecondLevel.ariaExpanded = 'false';
                        isSubmenuOpen = false;
                        let submenu = btnCollapserSecondLevel.parentElement.parentElement.parentElement.nextElementSibling;
                        $(submenu).slideUp('slow');
                    }
                });
            }

            for (let i = 0; i < optionLevelOne.length; i++) {
                optionLevelOne[i].addEventListener("mousedown", function (e) {
                    var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                    var btnSubList = this.querySelector('.menu-item__sublist');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                    }

                    if (isSubmenuGrandChildOpen == true) {
                        e.preventDefault();
                    }

                    if (isSubmenuGrandChildOpen != true) {

                        if (isSubmenuOpen == true && isSubmenuGrandChildOpen == false) {
                            isSubmenuOpen = false;
                            $(btnSubList).addClass('hover');
                            $(submenuBtnToggleIcon).addClass('hover');

                        } else if (isSubmenuOpen == false && isSubmenuGrandChildOpen == false) {
                            isSubmenuOpen = true;
                            $(btnSubList).removeClass('hover');
                            $(submenuBtnToggleIcon).removeClass('hover');

                        } else if (isSubmenuGrandChildOpen == true) {
                            isSubmenuOpen = true;
                        }
                    }
                });
            }

            for (let i = 0; i < optionLevelTwo.length; i++) {
                optionLevelTwo[i].addEventListener("mouseenter", function () {
                    var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                    }

                    if (submenuGrandchild) {
                        isSubmenuGrandChildOpen = true;

                        $(optionLevelTwo[i]).addClass('hover2');
                        $(submenuBtnToggleIcon).addClass('hover2');

                        if (isSubmenuGrandChildOpen == true) {
                            if (isMobile == true) {
                                $(submenuGrandchild).slideDown();
                            } else {
                                $(submenuGrandchild).show();
                            }
                        }
                    }
                });
            }

            for (let i = 0; i < optionLevelTwo.length; i++) {
                optionLevelTwo[i].addEventListener("mouseleave", function () {
                    var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                    }

                    if (submenuGrandchild) {
                        isSubmenuOpen = false;
                        isSubmenuGrandChildOpen = false;
                        $(optionLevelTwo[i]).removeClass('hover2');
                        $(submenuBtnToggleIcon).removeClass('hover2');

                        if (isMobile == true) {
                            $(submenuGrandchild).slideUp();
                        } else {
                            $(submenuGrandchild).hide();
                        }
                    }
                });
            }

            for (let i = 0; i < optionLevelTwo.length; i++) {
                optionLevelTwo[i].addEventListener("mousedown", function () {
                    var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                    var submenuBtnToggle = this.querySelector('.btn-submnenu');

                    if (submenuBtnToggle) {
                        var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                    }

                    if (isSubmenuOpen == true && isSubmenuGrandChildOpen == true) {
                        $(submenuGrandchild).slideUp('slow');
                        $(optionLevelTwo[i]).removeClass('hover2');
                        isSubmenuOpen = false;
                        $(submenuBtnToggleIcon).removeClass('hover2');

                    } else if (isSubmenuOpen == false && isSubmenuGrandChildOpen == true) {
                        $(submenuGrandchild).slideDown('slow');
                        isSubmenuOpen = true;
                    }
                });
            }
        }

        optionUser[0].addEventListener("mouseenter", function () {
            if (window_width < 768 && isOptionUser == false) {
                $(optionUserSubmenu[0]).addClass('show');
            }
        });

        optionUser[0].addEventListener("mouseleave", function () {
            if (window_width < 768) {
                $(optionUserSubmenu[0]).removeClass('show');
            }
        });

        optionUser[0].addEventListener("mousedown", function () {
            isOptionUser = !isOptionUser;

            if (isOptionUser == false) {
                if (window_width < 768) {
                    $(optionUserSubmenu[0]).removeClass('show');
                }

            } else {
                if (window_width < 768) {
                    $(optionUserSubmenu[0]).addClass('show');
                }
            }
        });
    });

    function toggleClassIconFirstLevel(old, actual) {
        oldButtonFirstLevel = actual;

        if(old == null || old == '') {
            actual.classList.add('open-menu');

        } else if((old != null || old != '') && old != actual) {

            if(old != actual) {
                if(old.classList.contains('open-menu')) {
                    old.classList.remove('open-menu');
                    toggleClassAllIconsSecond();
                }
            } else if(old == actual) {
                if (actual.classList.contains('open-menu')) {
                    actual.classList.remove('open-menu');
                } else {
                    actual.classList.add('open-menu');
                }
            }
            
            actual.classList.add('open-menu');
            
        } else if((old != null || old != '') && old == actual) {
            
            if(old != actual) {
                if (old.classList.contains('open-menu')) {
                    old.classList.remove('open-menu');
                }
            } else if(old == actual) {
                if (!actual.classList.contains('open-menu')) {
                    actual.classList.add('open-menu');
                } else {
                    actual.classList.remove('open-menu');
                    toggleClassAllIconsSecond();
                }
            }
        }
    }
    
    function toggleClassIconSecondLevel(old, actual) {
        oldButtonSecondtLevel = actual;

        if(old == null || old == '') {
            actual.classList.add('open-menu');

        } else if((old != null || old != '') && old != actual) {
            if(old != actual) {
                if(old.classList.contains('open-menu')) {
                    old.classList.remove('open-menu');
                }
            } else if(old == actual) {
                if (actual.classList.contains('open-menu')) {
                    actual.classList.remove('open-menu');
                } else {
                    actual.classList.add('open-menu');
                }
            }

            actual.classList.add('open-menu');

        } else if((old != null || old != '') && old == actual) {            
            if(old != actual) {
                if (old.classList.contains('open-menu')) {
                    old.classList.remove('open-menu');
                }
            } else if(old == actual) {
                if (!actual.classList.contains('open-menu')) {
                    actual.classList.add('open-menu');
                } else {
                    actual.classList.remove('open-menu');
                }
            }
        }
    }

    function toggleClassAllIcons() {
        let arrIcons = [];
        arrIcons.push(btnSubmenuLevelOne, btnSubmenuLevelTwo);

        arrIcons.map((btnsGroup) => {
            for (let i = 0; i < btnsGroup.length; i++) {
                const btn = btnsGroup[i];

                if(btn.classList.contains('open-menu')) btn.classList.remove('open-menu')
            }
        })
    }

    function toggleClassAllIconsSecond() {
        for (let i = 0; i < btnSubmenuLevelTwo.length; i++) {
            const btn = btnSubmenuLevelTwo[i];

            if (btn.classList.contains('open-menu')) btn.classList.remove('open-menu');
        }
    }

    function watcherSubmenuFirstLevel(old, actual) {
        oldSubmenuFirstLevel = old;
        actualSubmenuFirstLevel = actual;
        oldSubmenuFirstLevel = actualSubmenuFirstLevel;
        
        if(old == null || old == '') {
            $(actualSubmenuFirstLevel).slideToggle();
            
        } else if((old != null || old != '') && old != actual) {
            setTimeout(() => {
                $(old).slideUp();
                $(actualSubmenuFirstLevel).slideToggle();
            }, 500);
            
        } else if((old != null || old != '') && old == actual) {

            $(actualSubmenuFirstLevel).slideToggle();
            watcherSubmenuSecondLevel(null, null)
        }
    }
    
    function watcherSubmenuSecondLevel(old, actual) {
        oldSubmenuSecondLevel = old;
        actualSubmenuSecondLevel = actual;
        oldSubmenuSecondLevel = actualSubmenuSecondLevel;
        
        if(old == null || old == '') {
            $(actualSubmenuSecondLevel).slideToggle();
            
        } else if (old == null || old == ''){
            $(actualSubmenuSecondLevel).slideUp();

        }else if((old != null || old != '') && old != actual) {
            setTimeout(() => {
                $(old).slideUp();
                $(actualSubmenuSecondLevel).slideToggle();
            }, 500);
            
        } else if((old != null || old != '') && old == actual) {
            $(actualSubmenuSecondLevel).slideToggle();
        }
    }

    function closeAll() {
        submenuChild = document.getElementsByClassName('submenu');
        submenuGrandchild = document.getElementsByClassName('submenu-item__grandchild');

        for (let i = 0; i < submenuChild.length; i++) {
            $(submenuChild[i]).slideUp();
        }
        
        for (let i = 0; i < submenuGrandchild.length; i++) {
            $(submenuGrandchild[i]).slideUp();
        }
    }

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getStatusSubmenu() {
        if (statusOpenSubmenu) {
            $(this).parent().parent().addClass("open");
        } else {
            setTimeout(() => {
                $(this).parent().parent().removeClass("open");
            }, 350);
        }
    }

    this.addEventListener("resize", (event) => {
        widthActual();
        getDevice();

        let menuDisplay = menu.style.display;
        let submenuDisplay = menu.style.display;

        if (window_width >= 768) {
            isMenuOpen = false;
            $(optionUserSubmenu[0]).removeAttr('style');
            isOptionUser = false;

            isSubmenuOpen = false;
            isSubmenuGrandChildOpen = false;

            $(menu).removeClass('show');
            $(body).css('overflow', 'auto');
            $(coverhead).css('display', 'none');

            oldSubmenuFirstLevel = null;
            actualSubmenuFirstLevel = null;

            oldSubmenuSecondLevel = null;
            actualSubmenuSecondLevel = null;

            closeAll();
            
        } else {
            closeAll();
        }

        if (window_width >= 768 && $(optionUserSubmenu[0]).hasClass('show')) {
            $(optionUserSubmenu[0]).removeClass('show');
        }

        if (window_width < 768 && menuDisplay === 'block' && isMenuOpen == false) {
            $(menu).hide();
            isMenuOpen = false;
        } else if (window_width > 768 && menuDisplay === 'none' && isMenuOpen == false) {
            $(menu).show();
            isMenuOpen = false;
        }
    });

    function getDevice() {
        let navigatorDevice = navigator.userAgent;
        if (navigatorDevice.match(/Android/i) || navigatorDevice.match(/webOS/i) || navigatorDevice.match(/iPhone/i) || navigatorDevice.match(/iPad/i) || navigatorDevice.match(/iPod/i) || navigatorDevice.match(/BlackBerry/i) || navigatorDevice.match(/Windows Phone/i)) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    function getTypeHeader() {
        sectionHeader = document.getElementById('shopify-section-header');

        inputHeaderType = document.getElementById('sticky-header');

        inputHeaderTypeValue = inputHeaderType.value;

        $(inputHeaderTypeValue).on("change", function () {
        })

        if (inputHeaderTypeValue == 'yes') {
            $(sectionHeader).addClass('stiky-menu');
        } else if (inputHeaderTypeValue == 'no') {
            $(sectionHeader).removeClass('stiky-menu');
        }
    }

    function hiddeMenuMobile() {
        btnMenu = document.getElementById("btn-menu");

        window.addEventListener('click', function (e) {
            if (isMenuOpen == true) {
                
                if (!document.getElementById('siteHeaderId').contains(e.target)) {
                    isMenuOpen = false;
                    $(menu).removeClass('show');
                    $(body).css('overflow', 'auto');
                    $(coverhead).css('display', 'none');
                    closeAll();
                    toggleClassAllIcons();
                }
            } else {
                isMenuOpen = false;
            }
        });
    }

    function hideOptionUser() {
        if (window_width < 768) {
            window.addEventListener('click', function (e) {
                if (!document.getElementById('siteUserId').contains(e.target)) {
                    if (isOptionUser == false) {
                        isOptionUser = true;
                    } else {
                        isOptionUser = false;
                    }
                }
            });
        }

        if (window_width >= 768) {
            window.addEventListener('mouseover', function (e) {
                if (document.getElementById('btn-submnenu-user').contains(e.target)) {
                    $(optionUserSubmenu[0]).addClass('show');

                } else {
                    $(optionUserSubmenu[0]).removeClass('show');
                }
            });
        }
    }
})($)
